export default __webpack_public_path__ + "static/media/csi_worship_resource_active.9c73fe84.svg";